import React, { useState, useEffect } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  DialogContentText,
} from "@mui/material";

import Draggable from "react-draggable";

import CRUDPageHeader from "../../components/CRUDPageHeader";
import BancaProtheusForm from "src/forms/BancaProtheusForm";
import {
  atualizarContaBancaria,
  buscarContasBancarias,
  buscarContasBancariasPorTexto,
  cadastrarContaBancaria,
  deletarContaBancaria,
} from "../../services/api-conciliacao.service";
import { idEmpresaFromComboIds } from "../../utils/idEmpresa";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const GruposEconomicos = () => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      id: "id_conciliacao_conta_bancaria",
      label: "ID",
      field: "id_conciliacao_conta_bancaria",
    },
    { id: "codigo_banco", label: "Banco", field: "codigo_banco" },
    { id: "agencia", label: "Agência", field: "agencia" },
    { id: "conta_bancaria", label: "Conta Bancária", field: "conta_bancaria" },
    { id: "conta_protheus", label: "Conta Protheus", field: "conta_protheus" },
    { id: "conta_dominio", label: "Conta Domínio", field: "conta_dominio" },
    { id: "tipo_conta", label: "Tipo Conta Bancária", field: "tipo_conta" },
  ];

  const handleAtualizar = async () => {
    setLoading(true);
    try {
      const response = await buscarContasBancarias(idEmpresa);
      setData(response.contasBancarias);
      setLoading(false);
    } catch (err) {
      if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    idEmpresa ? handleAtualizar() : setData([]);
  }, [idEmpresa]);

  const handleOpenModal = (rowData) => {
    setEditRowData(rowData);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    console.log(data);

    if (!editRowData.id_conciliacao_conta_bancaria) {
      // Cadastra
      await cadastrarContaBancaria(idEmpresa, data)
        .then(async (response) => {
          setMsg(response.mensagem);
          handleOpenSnackbarSucesso();
          // Buscar dados novamente para renderizar
          handleAtualizar();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    } else {
      //Atualiza
      await atualizarContaBancaria(
        idEmpresa,
        editRowData.id_conciliacao_conta_bancaria,
        data
      )
        .then(async (response) => {
          setMsg(response.mensagem);
          // Buscar dados novamente para renderizar
          handleOpenSnackbarSucesso();
          handleAtualizar();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    }

    handleCloseModal();
  };

  const handleDelete = async () => {
    //Deleta
    await deletarContaBancaria(
      idEmpresa,
      editRowData.id_conciliacao_conta_bancaria
    )
      .then(async (response) => {
        setMsg(response.mensagem);
        // Buscar dados novamente para renderizar
        handleOpenSnackbarSucesso();
        handleAtualizar();
        handleCloseDialogExclusao();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleDebounceChange = async (event) => {
    if (idEmpresa) {
      try {
        const response = await buscarContasBancariasPorTexto(
          idEmpresa,
          event.target.value
        );
        setData(response.contasBancarias);
      } catch (err) {
        if (err.response?.status === 404) {
          setData([]);
        } else if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      }
    } else {
      setMsg("Necessário selecionar uma Empresa.");
      handleOpenSnackbarErro();
    }
  };

  const handleGrupoECnpjChange = (ids) => {
    setIdEmpresa(idEmpresaFromComboIds(ids));
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <>
            <AccountBalanceWalletIcon />
          </>
        }
        headerTitle="Contas Bancárias"
        modalButtonLabel={"Adicionar"}
        handleOpenModal={handleOpenModal}
        handleDebounceChange={handleDebounceChange}
        AutoCompleteRequired={idEmpresa ? false : true}
        AutoCompleteEmpresaCnpj
        handleEmpresaCnpjChange={handleGrupoECnpjChange}
      />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{}}
        maxWidth="xl" // Defina o tamanho máximo do modal
      >
        <DialogTitle>
          <div className={styles.tituloPopupContainer}>
            <AccountBalanceWalletIcon sx={{ fontSize: "30px" }} />
            <h1 className={styles.tituloPopup}>Conta Bancária - Protheus</h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <BancaProtheusForm
            bancaProtheusValues={Object.assign({}, editRowData)}
            onClose={handleCloseModal}
            onSubmit={handleSaveChanges}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente a conta bancária{" "}
            {editRowData.conta_bancaria}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default GruposEconomicos;
